import jwt_decode, { JwtPayload } from "jwt-decode";
import { VoucherEntry } from "./models/Models";

// Extend JwtPayload to include user_id which could be string or number
interface CustomJwtPayload extends JwtPayload {
  user_id?: string | number;
}

export const extractUserID = (): string | undefined => {
  const tokensString = localStorage.getItem('authTokens');

  // Handle case where tokensString is null
  if (!tokensString) {
    return undefined;
  }

  try {
    // Parse the token from localStorage
    const parsedTokens = JSON.parse(tokensString) as { access: string };

    if (!parsedTokens.access) {
      console.error('Access token not found');
      return undefined;
    }

    // Decode the JWT token
    const decodedToken = jwt_decode<CustomJwtPayload>(parsedTokens.access);

    // Safely return user_id as a string, converting it if necessary
    const userId = decodedToken?.user_id;
    return userId ? String(userId) : undefined;

  } catch (error) {
    console.error('Error decoding token:', error);
    return undefined;
  }
}
export const convertFormDataToVoucherEntries = (formData: FormData): VoucherEntry[] => {
  // Convert FormData to a plain object
  const dataObject: Record<string, string> = {};
  formData.forEach((value, key) => {
      dataObject[key] = value.toString();
  });

  // Create a single VoucherEntry object from the dataObject
  const voucherEntry: VoucherEntry = {
      date_en: dataObject['date_en'] || "",
      fiscal_year_date: dataObject['fiscal_year_date'] || "",
      fiscal_start: dataObject['fiscal_start'] || "",
      date_ne: dataObject['date_ne'] || "",
      debitamt: dataObject['debitamt'] || "",
      creditamt: dataObject['creditamt'] || "",
      user_no: parseInt(dataObject['user_no'] || "0"),
      chequeno: dataObject['chequeno'] || "",
      bearername: dataObject['bearername'] || "",
      billing_no: dataObject['billing_no'] || "",
      voucher_type: dataObject['voucher_type'] || "",
      is_debit: parseInt(dataObject['is_debit'] || "0"),
      trancomment: dataObject['trancomment'] || "",
      bill_print: parseInt(dataObject['bill_print']) || 0,
      glid: dataObject['glid'] || "",
      cash_sglsn: dataObject['cash_sglsn'] || "",
      voucher_no: dataObject['voucher_no'] || "",
      voucher_no_1: dataObject['voucher_no_1'] || "",
      trans_counter_code: dataObject['trans_counter_code'] || "",
      voucher_kind: dataObject['voucher_kind'] || "",
      member_sn: dataObject['member_sn'] || "",
      depositmonth: dataObject['depositmonth'] || "",
      deposityear: dataObject['deposityear'] || "",
      particularid: dataObject['particularid'] || "",
      sglsn: dataObject['sglsn'] || "",
      bank_sglsn: dataObject['bank_sglsn'] || "",
      dep_particular_id: dataObject['dep_particular_id'] || "",
      mem_cate_id: parseInt(dataObject['mem_cate_id'] || "0"),
      particular_name: dataObject['particular_name'] || "",
      view_full_leader: dataObject['view_full_leader'] || false,
      ledger_start_date:  dataObject['ledger_start_date'] || "",
      ledger_end_date:  dataObject['ledger_end_date'] || "",

  };

  // Return an array containing the single VoucherEntry
  return [voucherEntry];
};
